/** Trigger a browser download of a blob under the given filename. */
export function download(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke lazily so slow engines/browsers finish reading the blob first.
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
